/**
 * Deployment scope — the parliamentary constituency this instance covers.
 *
 * One place to change when the platform is pointed at a different seat.
 * Everything geographic reads from here rather than hardcoding a name:
 * the dashboards, the map's PC filter, the Geo Intel rollups, and the
 * segment dropdowns.
 *
 * Set REACT_APP_LOK_SABHA to override at build time. Set it to an empty
 * string for a genuinely state-wide deployment — every consumer treats a
 * falsy value as "no parliamentary restriction" and falls back to the
 * previous state-wide behaviour.
 *
 * MUST match the canonical spelling used by backend/src/data/ls_to_ac.json.
 * The alias layers on both sides accept the common variants
 * ("Thoothukudi", "Tuticorin"), but the canonical form keeps cache keys and
 * display labels consistent.
 */
export const LOK_SABHA = process.env.REACT_APP_LOK_SABHA ?? 'Thoothukkudi';

/**
 * The district those assembly segments sit in.
 *
 * All six segments of the Thoothukudi parliamentary seat share one district,
 * so the district tier is a single fixed value here rather than something the
 * user picks. Stored values vary in case and transliteration
 * ("Thoothukudi" / "THOOTHUKUDI"), so consumers should match on the
 * normalized key rather than the string.
 */
export const DISTRICT = process.env.REACT_APP_DISTRICT ?? 'Thoothukudi';

/** Normalized form, matching the key geo-intel aggregations group on. */
export const DISTRICT_KEY = String(DISTRICT).toLowerCase().replace(/[\s.\-',/()]/g, '');

/** True when this build is scoped to one parliamentary seat. */
export const IS_SEAT_SCOPED = Boolean(LOK_SABHA);

export default LOK_SABHA;
